import { createDownloadWithProgressThunk } from 'partner360/components/asyncContentWrapper/model'
import { FIN_COCKPIT_DOWNLOAD_TYPE_PREFIX } from 'partner360/features/financialCockpit/constants'

import { downloadProgress, downloadStarted } from '../actions'

export const downloadWithProgress = createDownloadWithProgressThunk(
  FIN_COCKPIT_DOWNLOAD_TYPE_PREFIX,
  { downloadStarted, downloadProgress }
)
